import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandS } from '@sorare/core/src/atoms/typography';

const StyledSection = styled(Vertical).attrs({ gap: 1.5 })`
  width: 100%;
`;

const SectionTitle = styled(BrandS)`
  display: flex;
  align-items: center;
  gap: var(--unit);
  & svg {
    color: var(--icon-color, currentColor);
  }
`;

type Props = {
  icon: ReactNode;
  iconColor?: string;
  title: ReactNode;
  extraTitleElement?: ReactNode;
  children: ReactNode;
};

export const MissionSection = ({
  icon,
  iconColor,
  title,
  extraTitleElement,
  children,
}: Props) => (
  <StyledSection>
    <SBHorizontal>
      <SectionTitle
        style={
          iconColor
            ? ({ '--icon-color': iconColor } as CSSProperties)
            : undefined
        }
      >
        {icon}
        {title}
      </SectionTitle>
      {extraTitleElement}
    </SBHorizontal>
    {children}
  </StyledSection>
);
